import React,{useEffect, useState} from 'react'
import styled, { createGlobalStyle, keyframes, css } from "styled-components";
import { isMobile} from 'react-device-detect';
import { T } from "./Util";
import { getRequestToEmail } from '../Logic/index01';
import { construct } from './Util';

const History = () => {

 const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
    `;


  const Shell = styled.div`
        display: flex;
        width:100%;
        height: 100vh;
        overflow:scroll;
        `;


  const Body = styled.div`
        flex: 1;
        display: flex;
        width:100%;
        flex-direction: column;
    `;


  const Card = styled.div`
    background: ${T.surface};
    border-radius: 16px;
    border: 1px solid ${T.border};
    transition: box-shadow 0.2s, transform 0.2s;
    &:hover { box-shadow: 0 8px 30px rgba(0,0,0,.08); 
    transform: translateY(-2px); }
    animation: ${fadeUp} 0.4s ease both;
    animation-delay: ${({ $delay }) => $delay || "0s"};
    `;



  const TableCard = styled(Card)`
        padding: 20px;
        `;

  const TableHeader = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        `;

  const FilterGroup = styled.div`
        align-items: center;
        gap: 8px;
        `;

  const FilterTabs = styled.div`
        border: 1px solid ${T.border};
        border-radius: 10px;
        overflow: hidden;
        `;

  const FilterTab = styled.button`
        padding: 6px 12px;
        font-size: 12px;
        font-family: ${T.font};
        font-weight: 500;
        border: none;
        cursor: pointer;
        transition: background 0.15s, color 0.15s;
        ${({ $active }) => $active ? css`
            background: #1f2937;
            color: #fff;
        ` : css`
            background: #fff;
            color: ${T.muted};
            &:hover { background: #f9fafb; }
        `}
        `;

  const DateSelect = styled.select`
        font-size: 12px;
        color: ${T.muted};
        border: 1px solid ${T.border};
        border-radius: 10px;
        padding: 6px 12px;
        background: #fff;
        font-family: ${T.font};
        outline: none;
        cursor: pointer;
        `;

  const Table = styled.table`
        width: 100%;
        border-collapse: collapse;
        `;

  const THead = styled.thead`
        tr { border-bottom: 1px solid ${T.border}; }
        th {
            padding: 0 8px 12px 0;
            font-size: 11px;
            font-weight: 500;
            color: ${T.subtle};
            text-align: left;
        }
        `;

 const TBody = styled.tbody`
    
 `;

 const TRow = styled.tr`
        border-bottom: 1px solid #f9fafb;
        transition: background 0.1s;
        &:last-child { border-bottom: none; }
        &:hover { background: #f8faff; }
        td {
            padding: 12px 8px 12px 0;
            font-size: 13px;
            color: ${T.text};
            vertical-align: middle;
  }`;


  const MonoCell = styled.td`
        font-family: ${T.mono} !important;
        font-size: 11.5px !important;
        color: ${T.muted} !important;
        `;


  const CarType = styled.td` color: ${T.muted} !important; `;

   
 
  const Badge = styled.span`
        display: inline-block;
        padding: 3px 10px;
        border-radius: 20px;
        font-size: 11.5px;
        font-weight: 500;

        ${({ $type }) => {
            if ($type === "Complete")  return css`background: ${T.greenLight}; color: ${T.greenText};`;
            if ($type === "Progress") return css`background: ${T.amberLight}; color: ${T.amberText};`;
            if ($type === "Terminate") return css`background: ${T.redLight};   color: ${T.redText};`;
        }}
        `;

    const TimeCell = styled.td`
        font-size: 11.5px !important;
        color: ${T.subtle} !important;
        `;

    const LocationDots = styled.td`
        span {
            display: flex;
            align-items: center;
            gap: 3px;
            font-size: 11px;
            color: ${T.subtle};
        }
        `;

    const Dot = styled.span`
        width: 8px; height: 8px;
        border-radius: 50%;
        background: ${({ $color }) => $color || "transparent"};
        border: ${({ $empty }) => $empty ? `1.5px solid ${T.border}` : "none"};
        display: inline-block;
        `;

    const Line_ = styled.span`
        width: 14px;
        height: 1px;
        background: ${T.border};
        display: inline-block;
        `;

    const MoreBtn = styled.td`
        color: ${T.subtle} !important;
        font-size: 18px !important;
        cursor: pointer;
        user-select: none;
        &:hover { color: ${T.text} !important; }
        `;




    const CardTitle = styled.p`
        font-size: 14px;
        font-weight: 600;
        color: ${T.text};
        `;



    const [activeTab, setActiveTab] = useState("All");
    const [tableData, setTableDta] = useState([]);
    const tabs = ["All", "Complete", "Progress", "Terminate"];
    const filterList = activeTab === "All" ? tableData : tableData.filter(r => activeTab === "Complete" ? r.complete === true : activeTab === "Progress" ? r.Status === true && r.cancel === false && r.complete === false : r.cancel === true && r.Status === true && r.complete === false);
    const dotColor = ["#9ca3af","#2563eb","#eff4ff","#d97706","#fef9c3","#713f12","#dc2626","#09fc05"];
  

    const pullInNotiication = async () => {
         let resList = await getRequestToEmail(construct(localStorage.getItem(process.env.REACT_APP_LS)),"createdAt");
          if(resList){
            setTableDta(resList);
         }
    }




  useEffect(() => {
    pullInNotiication();
  },[])



  return (
    <>
    
       <Shell>
        <Body>
            {/* ── TABLE ── */}
            <TableCard $delay="0.15s">
              <TableHeader>
                <CardTitle className="hidden md:block">Request History</CardTitle>
                <FilterGroup className="grid md:flex">
                  <FilterTabs>
                    {tabs.map(t => (
                      <FilterTab key={t} $active={activeTab == t} onClick={() => setActiveTab(t)}>{t}</FilterTab>
                    ))}
                  </FilterTabs>
                  <DateSelect>
                    <option>Today</option>
                    <option>This Week</option>
                    <option>This Month</option>
                  </DateSelect>
                </FilterGroup>
              </TableHeader>

              <Table>
                <THead>
                  {isMobile ?
                  <tr className="grid">
                    <th>Request ID</th>
                    <th>Usercode</th>
                    <th>Car Type</th>
                    <th>Status</th>
                    <th>Day &amp; Time</th>
                    <th>Location</th>
                    <th></th>
                  </tr>
                  :
                  <tr>
                    <th>Request ID</th>
                    <th>Usercode</th>
                    <th>Car Type</th>
                    <th>Status</th>
                    <th>Day &amp; Time</th>
                    <th>Location</th>
                    <th></th>
                  </tr>
                  }
                </THead>
                <TBody>
                  {tableData.length > 0  ?
                   filterList.map(row => (
                   isMobile && row.Status ?  
                    <TRow key={row.id} className="grid">
                      <MonoCell>#{row.requestId}</MonoCell>
                        <td>{row.accesscode}</td>
                        <CarType>{row.carType}</CarType>
                         <td><Badge $type={row.Status === true && row.cancel === false && row.complete  === false ? "Progress" : row.cancel == true ? "Terminate" : row.complete == true ? "Complete" : "n/a"}>{row.Status === true && row.cancel === false && row.complete  === false ? "Progress" : row.cancel === true ? "Terminate" : row.complete === true ? "Complete" : "n/a"}</Badge></td>
                        <TimeCell>{row.createdAt.toString().substring(0,row.createdAt.indexOf("T")-1)} at {row.createdAt.toString().substring(row.createdAt.indexOf("T")+1,row.createdAt.indexOf("."))}</TimeCell>
                        <LocationDots>
                          <span>
                            <Dot $color={Math.floor(Math.random() * tableData.length)}/>
                            <Line_/>
                            {row.complete === true ? <Dot $color={Math.floor(Math.random() * dotColor.length)}/> : <Dot  $empty />}
                          </span>
                        </LocationDots>
                    </TRow>
                    : row.Status ?
                     <TRow key={row.id}>
                        <MonoCell>#{row.requestId}</MonoCell>
                        <td>{row.accesscode}</td>
                        <CarType>{row.carType}</CarType>
                        <td><Badge $type={row.Status === true && row.cancel === false && row.complete  === false ? "Progress" : row.cancel == true ? "Terminate" : row.complete == true ? "Complete" : "n/a"}>{row.Status === true && row.cancel === false && row.complete  === false ? "Progress" : row.cancel === true ? "Terminate" : row.complete === true ? "Complete" : "n/a"}</Badge></td>
                         <TimeCell>{row.createdAt.toString().substring(0,row.createdAt.indexOf("T")-1)} at {row.createdAt.toString().substring(row.createdAt.indexOf("T")+1,row.createdAt.indexOf("."))}</TimeCell>
                        <LocationDots>
                          <span>
                            <Dot $color={dotColor[Math.floor(Math.random() * dotColor.length)]}/>
                            <Line_/>
                             {row.complete === true ? <Dot $color={dotColor[dotColor.length-1]}/> : null}
                          </span>
                        </LocationDots>
                        {/* <MoreBtn>⋮</MoreBtn> */}
                    </TRow>
                    : null
                    
                  )): null}
                </TBody>
              </Table>
            </TableCard>
         </Body>
        </Shell>
    </>
  )
}







export default History
